import { AvatarV2, ColorOption } from '@cimplico/components';
import { Firm } from '../../types/firm';
import { parseTitle } from '../../utilities/formatting';

type FirmSelectFirmNameProps = {
    firm: Firm;
    current: boolean;
};

function randomColor(): ColorOption {
    const colors = ['gray', 'red', 'yellow', 'green', 'blue', 'violet', 'indigo', 'pink', 'orange'];
    return colors[Math.floor(Math.random() * colors.length)] as ColorOption;
}

function FirmSelectFirmName({ firm, current }: FirmSelectFirmNameProps): JSX.Element {
    const linkStyle = 'hover:dark:bg-white/[0.09] hover:bg-gray-100 hover:text-gray-900 hover:dark:text-white/[0.87] text-left block mt-1';
    const content = (
        <button
            className={`flex items-center justify-between p-2 text-gray-500 max-w-[400px] ${
                current ? 'dark:bg-white/[0.09] bg-gray-100 text-gray-900 dark:text-white/[0.87]' : ''
            }`}
            disabled={current}
        >
            <div className="flex items-center">
                <div className="shrink-0">
                    <AvatarV2 alt={`${parseTitle(firm.name)}`} size="xs" color={firm.avatarHexColour || randomColor()} />
                </div>
                <p className="line-clamp-1 text-left pl-2">{firm.name}</p>
            </div>
            {current && <p className="text-xs">Current</p>}
        </button>
    );

    return (
        <>
            {current ? (
                <>{content}</>
            ) : (
                <a href={`/${firm.shortId}/dashboard`} className={linkStyle}>
                    {content}
                </a>
            )}
        </>
    );
}

export default FirmSelectFirmName;
